<template>
  <div class="connect_account onboarding_step">
    <div class="heading">
      <h2>1. Connect your <span class="google-logo"><g>G</g><g>o</g><g>o</g><g>g</g><g>l</g><g>e</g></span> Accounts</h2>
      <p>
        Connecting your Google accounts allows the platform to understand your website and
        provide more in-depth SEO recommendations and improved reporting.<br>
        Not set them all up? Not a problem; you can skip when you're ready.
      </p>
    </div>
    <div class="account_cards">
      <connect-analytics />
      <connect-search-console />
      <connect-business-profile />
    </div>
  </div>
</template>

<script>
import ConnectAnalytics from "../accounts/ConnectAnalytics";
import ConnectSearchConsole from "../accounts/ConnectSearchConsole";
import ConnectBusinessProfile from "../accounts/ConnectBusinessProfile";
export default {
  components: {
    ConnectBusinessProfile,
    ConnectSearchConsole,
    ConnectAnalytics,
  }
}
</script>

<style lang="scss" scoped>
.connect_account {
  height: 75vh;

  .heading {
    height: 25%;
    h2 {
      font-weight: 700;
      line-height: 1.25;
      letter-spacing: -0.042em;
      color: var(--primary-font-color);
      font-size: 2.5rem;
    }

    p {
      font-size: 1rem;
      line-height: 1.625;
      letter-spacing: -0.015625em;
      color: var(--secondary-font-color);
    }
  }

  .account_cards {
    height: 75%;
    width: 80%;
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin: 0 auto;

  }
}
</style>
